import { 
    SET_CURRENT_LANGUAGE
} from 'redux/actions/types/i18n';

export const setCurrentLanguage = payload => ({
    type: SET_CURRENT_LANGUAGE,
    payload,
});
